import { render, staticRenderFns } from "./POInfo.vue?vue&type=template&id=16be2a6d"
import script from "./POInfo.vue?vue&type=script&lang=js"
export * from "./POInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports